export default "__VITE_ASSET__CaSjTMS___"